import { NavLink } from "react-router-dom";

export default function BottomNav({ items }) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
      style={{ maxWidth: 480, margin: "0 auto" }}
    >
      <nav
        className="mx-3 mb-3 rounded-[28px] pointer-events-auto"
        style={{
          background: "rgba(255,255,255,0.72)",
          backdropFilter: "blur(28px) saturate(180%)",
          WebkitBackdropFilter: "blur(28px) saturate(180%)",
          border: "1px solid rgba(255,255,255,0.6)",
          boxShadow: "0 14px 40px rgba(15,23,42,0.10), 0 2px 8px rgba(15,23,42,0.05)",
        }}
        data-testid="bottom-nav"
      >
        <div className="flex items-center justify-around px-2 pt-2 pb-[max(env(safe-area-inset-bottom),0.5rem)]">
          {items.map(({ to, icon: Icon, label, testId, end, badge }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center gap-0.5 px-3 py-1.5 rounded-2xl transition-all duration-200 min-w-[56px] active:scale-90 ${
                  isActive ? "text-primary" : "text-slate-400 hover:text-slate-700"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span
                      className="absolute inset-0 rounded-2xl"
                      style={{ background: "rgba(34,184,224,0.10)" }}
                    />
                  )}
                  <div className="relative">
                    <Icon
                      size={22}
                      strokeWidth={isActive ? 2.6 : 2}
                      className={`relative transition-transform ${isActive ? "scale-110" : ""}`}
                    />
                    {badge > 0 && (
                      <span
                        data-testid={`${testId}-badge`}
                        className="absolute -top-1.5 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center shadow-md ring-2 ring-white"
                      >
                        {badge > 9 ? "9+" : badge}
                      </span>
                    )}
                  </div>
                  <span className={`relative text-[10px] font-semibold tracking-wide ${isActive ? "" : "opacity-80"}`}>
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
